import { AbstractControl, ValidatorFn, ValidationErrors } from "@angular/forms";

export class RegexConstants {
    public static EMAIL = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/;
    public static GREATER_THAN_ZERO = /^[+]?[1-9]\d*/;
    public static BETWEEN_1_AND_100 = /^[+]?[1-9][0-9]?$|^100$/;
    public static BETWEEN_1_AND_100_WITH_DECIMAL = /^[+]?[1-9][0-9]?(?:\.\d*)?$/;
    public static BETWEEN_0_AND_100_WITH_DECIMAL = /^[+]?[0-9][0-9]?(?:\.\d*)?$/;
    public static PASSWORD_STRENGTH = /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()\-__+.]){1,}).{8,}$/;
}

export function RegexValidator(reg: RegexConstants): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value !== null && !control.value.toString().match(reg)) {
            return { decimal: true };
        }
        return null;
    };
}